import { render, staticRenderFns } from "./ClaioContentsTool.vue?vue&type=template&id=118bf4e2&scoped=true&"
import script from "./ClaioContentsTool.vue?vue&type=script&lang=ts&"
export * from "./ClaioContentsTool.vue?vue&type=script&lang=ts&"
import style0 from "./ClaioContentsTool.vue?vue&type=style&index=0&id=118bf4e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118bf4e2",
  null
  
)

export default component.exports